export default __webpack_public_path__ + "static/media/slider3.1cbc06f4.jpg";